<template>
  <PageMain class="bg-w mt-20  ">
    <a-tabs default-active-key="1" type="card" class="search-tab pt-20">
      <a-tab-pane key="1" tab="寄件人地址">
        <Addr :type="1" />
      </a-tab-pane>
      <a-tab-pane key="2" tab="收件人地址" force-render>
        <Addr :type="2" />
      </a-tab-pane>
    </a-tabs>
  </PageMain>
</template>
<script>

/**
 * 如何使用vue
 * 这里做最基本的用法演示，详细请看vue的官网
 * https://cn.vuejs.org/v2/guide/
 */
import Addr from './address'

export default {
  name: 'Send',
  components: {
    Addr
  }

}
</script>

<style lang="scss" >
.search-tab{
  .ant-tabs-nav-scroll{
  padding: 0 20px;

  }
}
</style>
